module.exports = __webpack_public_path__ + "packs/media/images/pic08-781d1cb020b4c32288f68cc5ac4f5def.jpg";